import PatientDashboardTitle from "src/components/header/patientDashboardTitle";
import { HeaderElement, HeaderElementType } from "../types";
import ActionDashboardTitle from "src/components/header/actionDashboardTitle";

export const PublicHeader: HeaderElement[] = [
  // {
  //   title: 'Nurse Enrollment',
  //   redirectLink: '/enrollment',
  //   actionType: HeaderElementType.ROUTE,
  // },
  {
    title: 'Practice Registration',
    redirectLink: '/enrollments/new',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Resources',
    redirectLink: '',
    actionType: HeaderElementType.DRPODOWN,
    dropdown: [
       {
        title: 'Benefit Investigation Request Fax Form',
        redirectLink: '/assets/resources/completed-request.pdf',
      },
      {
        title: 'Quick Guide: Understanding your BI Results',
        redirectLink: '/assets/resources/QUTENZA_Quick_Guide_Understanding_Your_BI.pdf',
      },
      {
        title: 'Access Tool Kit',
        redirectLink: '/assets/resources/QZA-11-25-0005 v2.0 September 2026 v2.0 Access Tool Kit - D v1g_FINAL.pdf',
      },
      // {
      //   title: 'Patient Chart Documentation',
      //   redirectLink: '/assets/resources/patient_chart_documentation.pdf',
      // },
      // {
      //   title: 'Patient Reimbursement',
      //   redirectLink: '/assets/resources/patient_reimbursement.pdf',
      // },
      // {
      //   title: 'Letter of Medical Necessity - Patients Continuing',
      //   redirectLink: '/assets/resources/letter_of_medical_necessity-patients_continuing.docx',
      // },
      // {
      //   title: 'Letter of Medical Necessity - New Patients',
      //   redirectLink: '/assets/resources/letter_of_medical_necessity-patients_new.docx',
      // },
      // {
      //   title: 'Letter of Appeal',
      //   redirectLink: '/assets/resources/Averitas_Letter_of_Appeal.docx',
      // },
      {
        title: 'Reimbursement Resources',
        redirectLink: 'https://www.qutenzahcp.com/dpn/access/#resources',
      }, {
        title: 'BAA',
        redirectLink: '/assets/resources/NA-02-25-0002_HIPAA_BAA_Standalone.pdf',
      },
    ]
  },
];

export const AuthenticatedManufactureHeader: HeaderElement[] = [
  {
    title: 'Action Dashboard',
    redirectLink: '/todos_statistics',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Patients',
    redirectLink: '/patient_statistics',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Cases',
    redirectLink: '/statistics',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Resources',
    redirectLink: '',
    actionType: HeaderElementType.DRPODOWN,
    dropdown: [
     {
        title: 'Benefit Investigation Request Fax Form',
        redirectLink: '/assets/resources/completed-request.pdf',
      },
      {
        title: 'Quick Guide: Understanding your BI Results',
        redirectLink: '/assets/resources/QUTENZA_Quick_Guide_Understanding_Your_BI.pdf',
      },
      {
        title: 'Access Tool Kit',
        redirectLink: '/assets/resources/QZA-11-25-0005 v2.0 September 2026 v2.0 Access Tool Kit - D v1g_FINAL.pdf',
      },
      // {
      //   title: 'Patient Chart Documentation',
      //   redirectLink: '/assets/resources/patient_chart_documentation.pdf',
      // },
      // {
      //   title: 'Patient Reimbursement',
      //   redirectLink: '/assets/resources/patient_reimbursement.pdf',
      // },
      // {
      //   title: 'Letter of Medical Necessity - Patients Continuing',
      //   redirectLink: '/assets/resources/letter_of_medical_necessity-patients_continuing.docx',
      // },
      // {
      //   title: 'Letter of Medical Necessity - New Patients',
      //   redirectLink: '/assets/resources/letter_of_medical_necessity-patients_new.docx',
      // },
      // {
      //   title: 'Letter of Appeal',
      //   redirectLink: '/assets/resources/Averitas_Letter_of_Appeal.docx',
      // },
      {
        title: 'Reimbursement Resources',
        redirectLink: 'https://www.qutenzahcp.com/dpn/access/#resources',
      },
      {
        title: 'BAA',
        redirectLink: '/assets/resources/NA-02-25-0002_HIPAA_BAA_Standalone.pdf',
      },
     {
        title:'EOB Warehouse',
        redirectLink:'/eobs'
      },
      {
        title:'UploadEOB',
        redirectLink:'/eobs/new',
      },
      // {
      //   title: 'CEP',
      //   redirectLink: '',
      // },
    ]
  },
  {
    title: 'QutenzaHCP.com',
    redirectLink: 'https://www.qutenzahcp.com/',
    actionType: HeaderElementType.LINK,
  }
];
export const AuthenticatedAreaManagerHeader: HeaderElement[] = [
  {
    title: 'Action Dashboard',
    redirectLink: '/todos_statistics',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Patients',
    redirectLink: '/patient_statistics',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Cases',
    redirectLink: '/statistics',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Resources',
    redirectLink: '',
    actionType: HeaderElementType.DRPODOWN,
    dropdown: [
     {
        title: 'Benefit Investigation Request Fax Form',
        redirectLink: '/assets/resources/completed-request.pdf',
      },
      {
        title: 'Quick Guide: Understanding your BI Results',
        redirectLink: '/assets/resources/QUTENZA_Quick_Guide_Understanding_Your_BI.pdf',
      },
      {
        title: 'Access Tool Kit',
        redirectLink: '/assets/resources/QZA-11-25-0005 v2.0 September 2026 v2.0 Access Tool Kit - D v1g_FINAL.pdf',
      },
      // {
      //   title: 'Patient Chart Documentation',
      //   redirectLink: '/assets/resources/patient_chart_documentation.pdf',
      // },
      // {
      //   title: 'Patient Reimbursement',
      //   redirectLink: '/assets/resources/patient_reimbursement.pdf',
      // },
      // {
      //   title: 'Letter of Medical Necessity - Patients Continuing',
      //   redirectLink: '/assets/resources/letter_of_medical_necessity-patients_continuing.docx',
      // },
      // {
      //   title: 'Letter of Medical Necessity - New Patients',
      //   redirectLink: '/assets/resources/letter_of_medical_necessity-patients_new.docx',
      // },
      // {
      //   title: 'Letter of Appeal',
      //   redirectLink: '/assets/resources/Averitas_Letter_of_Appeal.docx',
      // },
      {
        title: 'Reimbursement Resources',
        redirectLink: 'https://www.qutenzahcp.com/dpn/access/#resources',
      },
      {
        title: 'BAA',
        redirectLink: '/assets/resources/NA-02-25-0002_HIPAA_BAA_Standalone.pdf',
      },
      {
        title:'EOB Warehouse',
        redirectLink:'/eobs'
      },
      {
        title:'UploadEOB',
        redirectLink:'/eobs/new',
      },
      // {
      //   title: 'CEP',
      //   redirectLink: '',
      // },
    ]
  },
  {
    title: 'QutenzaHCP.com',
    redirectLink: 'https://www.qutenzahcp.com/',
    actionType: HeaderElementType.LINK,
  }
];
export const AuthenticatedHCPHeader: HeaderElement[] = [
  {
    title: 'Submit Request',
    redirectLink: '/cases/new',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: <ActionDashboardTitle />,
    redirectLink: '/todos',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: <PatientDashboardTitle />,
    redirectLink: '/patient_dashboards',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Cases',
    redirectLink: '/cases',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Resources',
    redirectLink: '',
    actionType: HeaderElementType.DRPODOWN,
    dropdown: [
      {
        title: 'Benefit Investigation Request Fax Form',
        redirectLink: '/assets/resources/completed-request.pdf',
      },
      {
        title: 'Quick Guide: Understanding your BI Results',
        redirectLink: '/assets/resources/QUTENZA_Quick_Guide_Understanding_Your_BI.pdf',
      },
      {
        title: 'Access Tool Kit',
        redirectLink: '/assets/resources/QZA-11-25-0005 v2.0 September 2026 v2.0 Access Tool Kit - D v1g_FINAL.pdf',
      },
      // {
      //   title: 'Patient Chart Documentation',
      //   redirectLink: '/assets/resources/patient_chart_documentation.pdf',
      // },
      // {
      //   title: 'Patient Reimbursement',
      //   redirectLink: '/assets/resources/patient_reimbursement.pdf',
      // },
      // {
      //   title: 'Letter of Medical Necessity - Patients Continuing',
      //   redirectLink: '/assets/resources/letter_of_medical_necessity-patients_continuing.docx',
      // },
      // {
      //   title: 'Letter of Medical Necessity - New Patients',
      //   redirectLink: '/assets/resources/letter_of_medical_necessity-patients_new.docx',
      // },
      // {
      //   title: 'Letter of Appeal',
      //   redirectLink: '/assets/resources/Averitas_Letter_of_Appeal.docx',
      // },
      {
        title: 'Reimbursement Resources',
        redirectLink: 'https://www.qutenzahcp.com/dpn/access/#resources',
      },
      {
        title: 'BAA',
        redirectLink: '/assets/resources/NA-02-25-0002_HIPAA_BAA_Standalone.pdf',
      },
      {
        title: 'Upload EOB',
        redirectLink: '/eobs/new',
      },
    ]
  },
  {
    title: 'QutenzaHCP.com',
    redirectLink: 'https://www.qutenzahcp.com/',
    actionType: HeaderElementType.LINK,
  }
];
